import React from 'react';
import { FormattedMessage,useIntl   } from 'react-intl';
import styled from 'styled-components';
import { Images } from '../../../assets';
import { Events } from '@footprint/common-components';
import EventEmitter from 'eventemitter3';
import log from '../../../services/LogService';

const HeaderContainer = styled.div`
  color: white;
  display: flex;
  font-size: 1.25rem;
  font-weight: bold;
  justify-content: space-between;
  align-items: center;
`

const Headline = styled.div`
  font-size: 20px;
  font-family: Inter, sans-serif;
  font-weight: 700;
  color: #1e4e5f;
  margin-left: 10px;
  flex-grow: 1;
`

const CloseIcon = styled.img`
  width: auto;
`;

type Props = {
  matching?: any;
  emitter: EventEmitter;
}
const CheckoutHeader: React.FunctionComponent<Props> = (props) => {
  const { emitter, matching} = props
  useIntl();

  const handleClose = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    emitter.emit(Events.onCancelPress, matching);
  }

  return (
    <HeaderContainer>
        <Headline>
          <FormattedMessage id="drv.header.shoebox" />
        </Headline>
      <CloseIcon src={Images.close} onClick={handleClose}/>
    </HeaderContainer>
  );
}

export default CheckoutHeader;
